module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/blue-grey-beard-glasses/blue-grey-beard-glasses@2x.png"